import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.admallindia.com";
export const API = `${BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API, timeout: 15000 });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admall_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function resolveMedia(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url; // local public asset like /admall-logo.png
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
